module.exports = __webpack_public_path__ + "img/err_yellow.090ed497.svg";